export default __webpack_public_path__ + "static/media/icon-group-3.5.477bdf5a.png";